export const devicePaths = {
  absolute: '/:clientId/inventory',

  details: {
    absolute: '/:clientId/inventory/device/:productId/:deviceId',
    relative: 'device/:productId/:deviceId',
  },

  alertDetails: {
    absolute: '/:clientId/inventory/alert/:alertId',
    relative: 'alert/:alertId',
  },

  attackDetails: {
    absolute: '/:clientId/inventory/attack/:attackId',
    relative: 'attack/:attackId',
  },

  aiAnomaliesDetails: {
    absolute: '/:clientId/inventory/ai-anomalies/:anomalyId',
    relative: 'ai-anomalies/:anomalyId',
  },
} as const;
